import { render, staticRenderFns } from "./taxes-popover.vue?vue&type=template&id=9f056a9e&"
import script from "./taxes-popover.vue?vue&type=script&lang=js&"
export * from "./taxes-popover.vue?vue&type=script&lang=js&"
import style0 from "./taxes-popover.vue?vue&type=style&index=0&id=9f056a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports